import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReplaceProductPage } from './replace-product.page';

const routes: Routes = [
  {
    path: '',
    component: ReplaceProductPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReplaceProductPageRoutingModule {}
